// extracted by mini-css-extract-plugin
module.exports = {"root":"_15ooF","in-flex":"_1c3LK","inFlex":"_1c3LK","logo":"_3kuDJ","promotion":"_99NRx"};